<template>
  <div class="page-user">
    <PageHeader>
      <div class="heading">
        <h1>
          <router-link :to="{name: 'users'}">Users</router-link> / <strong class="name">{{ user.email }}</strong>
        </h1>

        <Btn primary hasIcon tooltip="Edit User">
          <router-link :to="{name: 'edit-user', params: {id: userId}}">
            <Sprite name="edit"/>
          </router-link>
        </Btn>
      </div>

      <div class="header-actions">
        <Btn secondary hasIcon tooltip="Delete User" @click="activateConfirm">
          <Sprite name="bin"/>
        </Btn>
      </div>
    </PageHeader>

    <div class="page-columns">
      <div class="col main">
        <div class="page-content">
          <p><strong>Name</strong>: {{user.name}}</p>
          <p><strong>Email</strong>: {{user.email}}</p>
          <p><strong>Admin</strong>: {{user.admin}}</p>

          <router-link
            class="btn is-primary"
            :to="{name: 'websites', params: {companyId: user.company_id}}">
            View Websites
          </router-link>

          <hr>

          <h2>Meta</h2>
          <p v-if="referral">
            {{referral}}
          </p>

          <p v-else>Nothing to show.</p>
        </div>
      </div>

      <div class="col side">
        <PageSummary>
          <div>
            <h1>Global User</h1>
            <p>
              This is the admin view for this user.
            </p>
          </div>
        </PageSummary>
      </div>
    </div>

    <router-view />

    <Confirm
      v-if="confirmActive"
      @confirm="deleteUser"
      @cancel="cancel"
      :message="deleteMessage"
      :link="{name: 'users'}"
    />
  </div>
</template>

<script>
import page from '@/mixins/page'
import pagination from '@/mixins/pagination'
import confirm from '@/mixins/confirm'

import {readUserData, updateUserData, deleteUserData} from '@/lib/users'

import PageHeader from '@/components/PageHeader'
import PageSummary from '@/components/PageSummary'
import Sprite from '@/components/Sprite'
import Confirm from '@/components/Confirm'
import Btn from '@/components/Btn'

export default {
  name: 'User',

  mixins: [page, pagination, confirm],

  props: {
    userId: {
      type: String,
      required: true
    }
  },

  components: {
    PageHeader,
    PageSummary,
    Confirm,
    Sprite,
    Btn
  },

  data() {
    return {
      user: {}
    }
  },

  methods: {
    getData() {
      readUserData(this.userId).then(({data}) => {
        this.user = data
      })
    },

    submitUser() {
      updateUserData(this.userId, this.user).then(({data}) => {
        this.user = data
      })
    },

    deleteUser() {
      deleteUserData(this.userId).then(() => {
        this.$router.push({name: 'users'})
      })
    }
  },

  computed: {
    title() {
      return this.user.email
    },

    referral() {
      return this.user.referral || false
    },

    deleteMessage() {
      return 'Are you sure you want to delete this user?'
    }
  },

  mounted() {
    this.getData()
  },

  watch: {
    $route() {
      this.getData()
    }
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.page-user
  @extend %page
</style>
